import React, { useState } from 'react';
import { LineChart as LineChartIcon, Trophy } from 'lucide-react';
import { cn } from '../lib/utils';
import TradeJournal from '../components/community/TradeJournal';
import Leaderboard from '../components/community/Leaderboard';

const TABS = [
  { key: 'journal', label: 'Trade Journal', icon: LineChartIcon },
  { key: 'leaderboard', label: 'Leaderboard', icon: Trophy },
];

export default function Community() {
  const [tab, setTab] = useState('journal');

  return (
    <div className="space-y-8" data-testid="community-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-white">Community</h1>
        <p className="mt-1 text-sm text-zinc-500">Log your trades, track your edge in R, and see where you rank.</p>
      </div>

      <div className="inline-flex rounded-xl border border-white/10 bg-ink-surface p-1" role="tablist">
        {TABS.map((t) => {
          const active = tab === t.key;
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`community-tab-${t.key}`}
              className={cn(
                'flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors',
                active ? 'bg-white text-black' : 'text-zinc-400 hover:text-white'
              )}
            >
              <Icon size={16} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'journal' ? <TradeJournal /> : <Leaderboard />}
    </div>
  );
}
